// @ts-nocheck
import { Component } from 'react'
import { AlertTriangle } from 'lucide-react'

export class WidgetErrorBoundary extends Component {
  state = { hasError: false, error: null }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center gap-2 p-3 rounded-md border border-destructive/30 bg-destructive/5 text-sm text-destructive">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span>Widget failed to render</span>
        </div>
      )
    }
    return this.props.children
  }
}
